<template>
    <div>
      <div class="d-flex justify-space-between mb-4">
        <div>
          <div class="page-title mb-2">แบบฟอร์มเพิ่มผู้ใช้บริการ</div>
        </div>
      </div>
      <divcard class="mt-5">
        <v-form ref="form" v-model="valid" lazy-validation>
        <div class="font-20 font-w-700">ข้อมูลโครงการหลัก</div>
        <div class="d-flex flex-column py-5">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อ-สกุล
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                :value="form.name"
                :rules="[(v) => !!v || 'กรุณาระบุชื่อ-สกุล']"
                @onChange="setFormField('name', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ประเภทผู้ใช้งาน
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <SelectBox
                theme="3"
                :value="form.customer_type"
                :placeholder="'โปรดระบุ'"
                :items="customerTypeList"
                item-text="name"
                item-value="name"
                :rules="[(v) => !!v || 'กรุณาระบุประเภทผู้ใช้งาน']"
                @onChange="setFormField('customer_type', $event)"
                ></SelectBox>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เบอร์โทร
              </div>
              <TextField
                theme="3"
                inputType="number"
                :value="form.phone"
                
                @onChange="setFormField('phone', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เลขบัตรประชาชน
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                :value="form.id_card_no"
                inputType="number"
  
                :rules="[
                  (v) => !!v || 'กรุณาระบุเลขบัตรประชาชน',
                  (v) => /^\d{13}$/.test(v) || 'เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก' 
                ]"
                @onChange="setFormField('id_card_no', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อหน่วยงาน (บริษัท วิสาหกิจ ชื่อกลุ่ม ไม่มีใส่ -)  
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                :value="form.organization_name"
                :rules="[(v) => !!v || 'กรุณาระบุชื่อหน่วยงาน']"
                @onChange="setFormField('organization_name', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เลขจดทะเบียน
              </div>
              <TextField
                theme="3"
                :value="form.register_no"
                :rule="[(v) => !!v || 'กรุณาระบุเลขจดทะเบียน']"
                @onChange="setFormField('register_no', $event)"
              ></TextField>
            </div>
          </div>
          
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แพลตฟอร์มที่รับบริการ
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <SelectBox
                theme="3"
                :value="form.customer_platform"
                :placeholder="'โปรดระบุ'"
                :items="platformList"
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'กรุณาระบุแพลตฟอร์มที่รับบริการ']"
                @onChange="setFormField('customer_platform', $event)"
                
              ></SelectBox>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รายละเอียดของกลุ่ม / บริษัท
              </div>
              <TextField
                theme="3"
                
                :value="form.organization_detail"
                @onChange="setFormField('organization_detail', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความต้องการ
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                
                :value="form.requirement"
                :rules="[(v) => !!v || 'กรุณาระบุความต้องการ']"
                @onChange="setFormField('requirement', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ที่อยู่
              </div>
              <TextField
                theme="3"
                :value="form.address"
                @onChange="setFormField('address', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                จังหวัด
              </div>
              <!-- <TextField
                theme="3"
                :value="form.province"
                @onChange="setFormField('province', $event)"
              ></TextField> -->
              <AutoBox theme="3" :items="provincesList" item-text="name" item-value="name" :value="form.province"
                @onChange="setFormField('province', $event)
"></AutoBox>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                อำเภอ
              </div>
              <!-- <TextField
                theme="3"
                :value="form.district"
                @onChange="setFormField('district', $event)"
              ></TextField> -->
              <AutoBox theme="3" :items="filteredDistricts" item-text="name" item-value="name" :value="form.district"
              @onChange="setFormField('district',$event)"></AutoBox>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                ตำบล
              </div>
              <!-- <TextField
                theme="3"
                
                :value="form.sub_district"
                @onChange="setFormField('sub_district', $event)"
              ></TextField> -->
              <AutoBox theme="3" :items="filteredSubdistricts" item-text="name" item-value="name"
              :value="form.sub_district" @onChange="setFormField('sub_district', $event)"></AutoBox>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ข้อมูลอื่นๆ
              </div>
              <TextArea
                theme="3"
                
                :value="form.other_information"
                @onChange="setFormField('other_information', $event)"
              ></TextArea>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                อีเมล
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                :value="form.email"
                :rules="[
                  (v) => !!v || 'กรุณาระบุอีเมล',
                  (v) => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง',
                ]"
                @onChange="setFormField('email', $event)"
              ></TextField>
            </div>
          </div>
  
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                พิกัด (ละติจูด)
              </div>
              <TextField
                theme="3"
                :value="form.latitude"
                @onChange="setFormField('latitude', $event)"
              ></TextField>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                พิกัด (ลองติจูด)
              </div>
              <TextField
                theme="3"
                :value="form.longitude"
                @onChange="setFormField('longitude', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                Facebook
                <TextField
                theme="3"
                :value="form.facebook"
                @onChange="setFormField('facebook', $event)"
              ></TextField>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-center gap-16 mb-n12  " >
          <div class="d-flex align-center " style="width:100%;transform: translateY(-36px);">
              <div class="mb-1 pr-4 black--text">
                สถานะ
              </div>
                <SwitchInset
                  :input-value="form.status"
                  @onChange="setFormField('status', $event)"
              ></SwitchInset>
              <span class="txt-normal">{{ form.status === 1 ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}}</span>
            </div>
          </div>
      </v-form>
      </divcard>
      <div  class="d-flex justify-space-between mt-10" >
        <div>
          <Button @onClick="routeBack" theme="2">ยกเลิก</Button>
        </div>
        <div >
          <Button @onClick="updateUser" theme="1">บันทึก</Button>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import TextField from "@/components/input/TextField.vue";
  import TextArea from "@/components/input/TextArea.vue";
  import SelectBox from "@/components/input/SelectBox";
  import Button from "@/components/input/Button";
  import SwitchInset from "@/components/input/SwitchInset";
  import AutoBox from "@/components/input/AutoBox";
  
  export default {
    name: "UserServiceHistoryEdit",
    components: { 
      TextField,
      Button,
      SelectBox,
      SwitchInset,
      TextArea,
      AutoBox
  },
    data() {
      return {
        keyword: "",
        status: "",
        form:{
          
        },
        provincesList: [],
        districtsList: [],
        subdistrictsList: [],
        filteredDistricts: [],
        filteredSubdistricts: [],
        paginate: {
          total: 1,
          per_page: 1,
          current_page: 1,
          last_page: 1,
        },
        platformList:[],
        customerTypeList:[],
        valid: true,
      };
    },
    async created() {
      await this.getMasterData();
      await this.getData();
    },
      watch: {
      form: {
        handler(newValue) {
        

          if (this.form.province) {
            const province_id = parseInt(this.provincesList.find(province => province.name === this.form.province)?.province_id)
            this.filteredDistricts = this.districtsList.filter(district => district.province_id === province_id)
          }

          if (this.form.district) {
              const province_id = parseInt(
                this.provincesList.find(
                  (province) => province.name === this.form.province
                )?.province_id
              );
              const district_id = parseInt(
                this.districtsList.find(
                  (district) => district.name === this.form.district && district.province_id === province_id
                )?.district_id
              );
              this.filteredSubdistricts = this.subdistrictsList.filter(
                (subdistrict) => subdistrict.district_id === district_id && subdistrict.province_id === province_id
              );
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
        async getMasterData() {
        let res = await this.$apiFire("UserServiceHistory/create");
            console.log('res',res)
            if (res) {
            this.platformList = res.data.customer_platforms;
            this.customerTypeList = res.data.customer_types;
            this.provincesList = res.data.provinces;
            this.districtsList = res.data.districts;
            this.subdistrictsList = res.data.subdistricts;
        }
        },
      async getData() {
        const payload = {
            id: this.$route.params.id,
            page: '',
            keyword: '',
        };

        let res = await this.$apiFire("UserServiceHistory/show", payload);
        if (res) {
          console.log('res',res)
          const province_id =  this.provincesList.find(
            (prov) => prov.name === res.data.province
          )?.province_id
          
          console.log('province_id',province_id)
              this.filteredDistricts = this.districtsList.filter(
            (district) => district.province_id === province_id
          )
          console.log('province_id', this.districtsList.filter(
            (district) => district.province_id === province_id
          ))
            this.filteredSubdistricts = this.subdistrictsList.filter(
            (sub_district) => sub_district.province_id === province_id
          )
          this.form = res.data;
     
            }
      },
      async updateUser(){
        if (this.$refs.form.validate()) {
            const payload = {
                id: this.$route.params.id,
                payload: {
                    ...this.form
                }
            }

          let res = await this.$apiFire("UserServiceHistory/update",payload);
          if (res) {
            console.log('res updated',res)  
            this.routeBack();
          }
        }
      },
      routeBack(){
          this.$router.push({
              name:'UserServiceHistory'
          })
      },
          setFormField(field, val) {
      this.form[field] = val

      if (field === 'province') {
        //get province_id from masterdata
        const province_id = parseInt(this.provincesList.find(province => province.name == val).province_id)
        this.filteredDistricts = this.districtsList.filter(district => district.province_id == province_id)
        this.form.district = '';
        this.form.sub_district = '';
      }

      if (field === 'district') {
        //get district_id from masterdata
         const province_id = parseInt(
            this.provincesList.find(
              (province) => province.name === this.form.province
            ).province_id
          );
          const district_id = parseInt(
            this.districtsList.find(
              (district) => district.name === this.form.district && district.province_id === province_id
            ).district_id
          );
          this.filteredSubdistricts = this.subdistrictsList.filter(
            (subdistrict) => subdistrict.district_id === district_id && subdistrict.province_id === province_id
          );

      // reset ค่า subdistrict
      this.form.sub_district = "";
      }
      this.$forceUpdate()
    },
  
    },
  };
  </script>
  
  <style scoped lang="scss">
  .custom-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  
    th,
    td {
      border: 1px solid var(--theme-color-eight);
      padding: 10px;
    }
  
    th {
      background-color: #ffffff;
      text-align: center;
      font-weight: bold;
    }
  
    .text-center {
      text-align: center;
    }
  
   
  }
  </style>
  
  